/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import { RouterSupportedDOCountry, SpreadTargetType } from "interfaces/enums";

export interface MMType {
  lastOrderOriginClabe?: string;
}
interface SliceState {
  spreadTargetType: SpreadTargetType;
  router_country_dest: RouterSupportedDOCountry;
  timezone: string;
}

/**
 * Initial state for each exchange
 */
const initialState: SliceState = {
  spreadTargetType: SpreadTargetType.Rate,
  router_country_dest: RouterSupportedDOCountry.US,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
};

export const presetsSlice = createSlice({
  name: "presets",
  initialState,
  reducers: {
    setRouterCountryDest: (
      state,
      action: { payload: RouterSupportedDOCountry },
    ) => {
      state.router_country_dest = action.payload;
    },

    setSpreadTargetType: (state, action: { payload: SpreadTargetType }) => {
      state.spreadTargetType = action.payload;
    },
    setTimezone: (state, action: { payload: string }) => {
      console.log(action.payload);
      state.timezone = action.payload;
    },
    reset: () => initialState,
  },
});

export const { reset, setRouterCountryDest, setSpreadTargetType, setTimezone } =
  presetsSlice.actions;

export type PresetsState = ReturnType<typeof presetsSlice.reducer>;
